import { Button } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { GetDealerListByLocation, GetDealerLocation } from '../../networkCalls';
import FotterMain from '../BaseComponents/FotterMain';
import Header from '../BaseComponents/Header';
import SEO from '../BaseComponents/SEO';

const ServiceNetwork = () => {

  const [loading, setLoading] = React.useState(true);
  const [locationDdl, setLocationDdl] = React.useState([])
  const [DealerDataList, setDealerDataList] = React.useState([]);

  const [states, setStates] = React.useState([]);
  const [cities, setCities] = React.useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [selectedState, setSelectedState] = React.useState(null);

  const validationSchema = yup.object({
    // state: yup
    //   .string('Select state')
    //   .required('Please select state'),
    // city: yup
    //   .string('Select city')
    //   .required('Please select city'),
  });

  const formik = useFormik({
    initialValues: {
      state: '',
      city: '',
      pincode: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("Form Submitted", values);
      var data = new FormData();
      data.append('state', values.state);
      data.append('city', values.city);
      data.append('pincode', values.pincode);
      for (var pair of data.entries()) {
        console.log(pair[0] + ', ' + pair[1]);
      }
      GetDealerListByLocation(data).then((res) => {
        console.log('res GetDealerListByLocation', res)
        switch (res.data.status) {
          case 1:
            setDealerDataList(res.data?.dealerList);
            return true;
          case 0:
            setDealerDataList([]);
            break;
          default:
            return;
        }
      });
    },
  });
  // https://www.hondaindiapower.com/admin/api/GetDealerLocation

  const pullGetDealerLocation = () => {
    setLoading(true)
    GetDealerLocation().then((res) => {
      console.log('GetDealerLocation---0-', res?.data?.location)
      setLoading(false);
      switch (res.data.status) {
        case 1:
          const transformedLocations = Object.entries(res.data.location);
          setStates(transformedLocations?.map(([state]) => state)); // Array of state
          setLocationDdl(transformedLocations);
          return true;
        case 0:
          setStates([]);
          setLocationDdl([]);
          break;
        default:
          return;
      }
    })
  }
  const handleStateChange = (event, value) => {
    setSelectedState(value);
    const selectedLocation = locationDdl.find(([state]) => state == value);
    setCities(selectedLocation ? Object.keys(selectedLocation[1]) : []); // Get cities based on selected state
    formik.setFieldValue('state', value);
    formik.setFieldValue('city', '');
  };

  const handleCityChange = (event, value) => {
    if (value) {
      formik.setFieldValue('city', value.label);
      const selectedState = formik.values.state;
      const citiesForState = locationDdl.find(([state]) => state == selectedState);
      if (citiesForState) {
        const [, cities] = citiesForState; // Get the cities object
        const selectedCityData = cities[value.label];
        if (selectedCityData) {
          const selectedPincodes = selectedCityData.pincode;
          setPincodeOptions(selectedPincodes);
          // formik.setFieldValue('pincode', selectedPincodes[0] || '');
          formik.setFieldValue('pincode', '');
        } else {
          setPincodeOptions([]);
          formik.setFieldValue('pincode', '');
        }
      } else {
        setPincodeOptions([]);
        formik.setFieldValue('pincode', '');
      }

    } else {
      formik.setFieldValue('city', '');
      setPincodeOptions([]);
      formik.setFieldValue('pincode', '');
    }
  };


  useEffect(() => {
    pullGetDealerLocation()
  }, []);



  const toTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    toTop();
  }, []);

  return (
    <>
      <SEO
        title="Honda India Power Products | Honda Service Network India"
        description="Honda India Power Products and Honda Service Network India offers high quality products and a comprehensive network of maintenance facilities for the customers."
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/service-network"
        type='Website' />
      <Header />
      <div className='innerpagebg pt-5 pb-5'>
        <div className='container mb-4'>
          <div className='row'>
            <div className='col-12  m-auto'>
              <div className="align-items-center text-center">
                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                  <span className='txtred'>DEALER</span> <span className='txtdgray'>NETWORK</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className='container' style={{ minHeight: 600 }}>
          <div className='row '>
            <div className='col-lg-12 col-mg-12 col-sm-12 col-12 m-auto'>
              <div className='card p-3 rounded shadow-sm'>
                <form onSubmit={formik.handleSubmit} autoComplete="off">
                  <div className='row'>
                    <div className='col-6 col-md-3'>
                      <Autocomplete
                        disablePortal
                        className='mb-3'
                        options={loading ? [{ label: "Loading...", id: 0 }] : states}
                        id="state"
                        name="state"
                        getOptionLabel={option => option.label || option} // Return label if it exists; otherwise, return the state name
                        // defaultValue={}
                        onChange={handleStateChange}
                        value={formik.values?.state}
                        sx={{ width: '100%' }}
                        renderInput={(params) => <TextField
                          variant="standard" {...params}
                          required
                          error={formik.touched.state && Boolean(formik.errors.state)}
                          helperText={formik.touched.state && formik.errors.state}
                          label="Select State" />}
                      />
                    </div>
                    <div className='col-12 col-md-3'>
                      <Autocomplete
                        disablePortal
                        className='mb-3'
                        options={cities.map(city => ({ label: city }))}
                        id="city"
                        name="city"
                        getOptionLabel={option => option.label}
                        onChange={handleCityChange}
                        value={formik.values.city ? { label: formik.values.city } : null}
                        sx={{ width: '100%' }}
                        renderInput={(params) => (
                          <TextField
                            variant="standard"
                            required
                            error={formik.touched.city && Boolean(formik.errors.city)}
                            helperText={formik.touched.city && formik.errors.city}
                            {...params}
                            label="Select City"
                          />
                        )}
                      />
                    </div>
                    <div className='col-12 col-md-3'>
                      <Autocomplete

                        className='mb-3'
                        options={pincodeOptions.map(pincode => ({ label: pincode }))}
                        id="pincode"
                        name="pincode"
                        getOptionLabel={option => option.label}
                        onChange={(event, value) =>
                          formik.setFieldValue('pincode', value ? value.label : '')
                        }
                        value={formik.values.pincode ? { label: formik.values.pincode } : null}
                        sx={{ width: '100%' }}
                        renderInput={(params) => (
                          <TextField

                            variant="standard"
                            {...params}
                            label="Select Pincode"
                          />
                        )}
                      />
                    </div>
                    <div className='col-12 col-md-3 d-flex'>
                      <Button color="error"
                        variant="contained"
                        className='mt-3 w-100 me-3' style={{ height: 36 }}
                        size='small'
                        type="submit">Submit</Button>
                      <Button color="error" variant='outlined'
                      onClick={()=>
                        window.location.reload(false)
                      }
                       style={{ height: 36 }}
                        className='w-100 mt-3' size='small'
                      >Reset</Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {DealerDataList && DealerDataList?.length > 0 ? <>
            <div className='card p-3  mt-3'>
              <div className='row'>
                {DealerDataList?.map((data, key) => (
                  <div className='col-12 mb-1 f12' key={key} >
                    <h6 className='mb-2 txtred'>{data?.dealerName}</h6>
                    <div><span className='fw-bold'>Address : </span>{data?.dealerAddress1}, {data?.dealerAddress2}, {data?.dealerAddress3}, {data?.dealerAddress4}, {data?.dealerCity}, {data?.dealerState}</div>
                    <div><span className='fw-bold'>Pin Code : </span>{data?.dealerPinCode}</div>
                    {data?.dealerEmail && data?.dealerEmail!='' ?  <div><span className='fw-bold'>Email : </span>{data?.dealerEmail}</div> : <></>}
                    {data?.dealerPhone && data?.dealerPhone!='' ?  <div><span className='fw-bold'>Phone : </span>{data?.dealerPhone}</div> : <></>}
                    <hr className='mt-1 mb-1' />
                  </div>
                ))}
              </div>
            </div>
          </> : <></>}
        </div>
      </div>
      <FotterMain />
    </>
  )
}

export default ServiceNetwork